import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=2e1f9ece&"
import script from "./Collection.vue?vue&type=script&lang=ts&"
export * from "./Collection.vue?vue&type=script&lang=ts&"
import style0 from "./Collection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports